<template>
  <div>
    <el-dialog
      ref="viewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="abow_dialog"
      width="1200px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-tabs
        v-model="activeTab"
        type="card"
      >
        <el-tab-pane
          label="零售户档案信息"
          name="archives"
        >
          <el-form
            ref="dialogViewForm"
            :model="dialogViewForm"
          >
            <div class="modal-box">
              <h3 class="modal-title">
                基础信息
              </h3>
              <div class="modal-row-box">
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="店名">
                      <el-input
                        v-model="dialogViewForm.storeName"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="地址">
                      <el-input
                        v-model="dialogViewForm.address"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="终端业态">
                      <el-input
                        v-model="dialogViewForm.storeTypeValue"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="所属省区">
                      <el-input
                        v-model="dialogViewForm.provinceName"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="所属城市">
                      <el-input
                        v-model="dialogViewForm.cityName"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="所属区县">
                      <el-input
                        v-model="dialogViewForm.countyName"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="维护人">
                      <el-input
                        v-model="dialogViewForm.manageUserName"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="是否销售卷烟">
                      <el-input
                        v-model="dialogViewForm.isSellTobaccoValue"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col
                    v-if="dialogViewForm.isSellTobacco === 1"
                    :span="6"
                  >
                    <el-form-item label="卷烟经营类型">
                      <el-input
                        v-model="dialogViewForm.cigaretteBusinessValue"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="modal-box">
              <h3 class="modal-title">
                联系信息
              </h3>
              <div class="modal-row-box">
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="联系人">
                      <el-input
                        v-model="dialogViewForm.ownerName"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="性别">
                      <el-input
                        v-model="dialogViewForm.genderStr"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="联系电话">
                      <el-input
                        v-model="dialogViewForm.phone"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="联系人1">
                      <el-input
                        v-model="dialogViewForm.linkman1"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="联系人1与店主关系">
                      <el-input
                        v-model="dialogViewForm.linkman1Relation"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="联系人1电话">
                      <el-input
                        v-model="dialogViewForm.linkman1Phone"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="联系人2">
                      <el-input
                        v-model="dialogViewForm.linkman2"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="联系人2与店主关系">
                      <el-input
                        v-model="dialogViewForm.linkman2Relation"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="联系人2电话">
                      <el-input
                        v-model="dialogViewForm.linkman2Phone"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="modal-box pic-container">
              <h3 class="modal-title">
                照片信息
              </h3>
              <div class="modal-row-box">
                <div style="margin: 8px 0;">
                  <show-preview :arr-file-data="imageFileList" />
                </div>
              </div>
            </div>
            <div class="modal-box">
              <h3 class="modal-title">
                备注信息
              </h3>
              <div class="modal-row-box">
                <el-row :gutter="10">
                  <el-col :span="24">
                    <el-form-item prop="remark">
                      <el-input
                        v-model="dialogViewForm.remark"
                        type="textarea"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="拜访记录">
          <view-table
            :table-columns="visitTableColumns"
            :table-data="visitListData"
            table-custom-height="540"
          />
        </el-tab-pane>
        <el-tab-pane label="物料使用记录">
          <view-table
            :table-columns="usageTableColumns"
            :table-data="usageListData"
            table-custom-height="540"
          />
        </el-tab-pane>
      </el-tabs>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
import viewTable from '@/components/viewTable'
// 图片预览
import showPreview from '@/components/showPreview'
// 零售户档案API
import { viewStoreInfoApi } from '@/api/v2/store';

import { loadStoreVisitReportListSelectDataApi, findDetailInfoByStoreIdApi } from '@/api/storeVisitReport'

export default {
  components: { viewTable, showPreview },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogViewForm: {},
      activeTab: '',
      visitTableColumns: [
        { label: '拜访日期', prop: 'visitDateStr', width: 150 },
        { label: '拜访时间', prop: 'visitPeriodStr', width: 150 },
        { label: '拜访停留时间', prop: 'visitTimeStr', width: 200 },
        { label: '拜访人', prop: 'operatorName', width: 120 },
        { label: '拜访目的', prop: 'visitPurpose' },
        { label: '拜访结果', prop: 'visitInfo' }
      ],
      visitListData: [],
      usageTableColumns: [
        { label: '使用日期', prop: 'visitDateStr', width: 150 },
        { label: '发放人', prop: 'operatorName' },
        { label: '物料名称', prop: 'materialsName' },
        { label: '单位', prop: 'unitName', width: 100 },
        { label: '数量', prop: 'amount', width: 100 },
        { label: '用途', prop: 'usedMethod', width: 100 },
      ],
      usageListData: [],
      imageFileList: [],
      baseUrl: process.env.VUE_APP_FILE_V2_API
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.activeTab = 'archives'
        _this.imageFileList = []
        _this.dialogViewForm = {}
        _this.loadStoreData()
      }
    }
  },
  methods: {
    // 加载数据
    loadStoreData () {
      let _this = this;
      viewStoreInfoApi({ id: _this.dataId }).then((response) => {
        const { data } = response
        _this.dialogViewForm = data;

        // 处理照片清单
        if (data.attachmentInfoDtoList && data.attachmentInfoDtoList.length > 0) {
          data.attachmentInfoDtoList.forEach((item) => {
            _this.imageFileList.push({
              name: item.attachmentName,
              url: _this.baseUrl + item.attachmentUrl,
              attachmentUrl: item.attachmentUrl,
            })
          })
        }
      })
      loadStoreVisitReportListSelectDataApi({ storeId: this.dataId }).then(res => {
        const { data } = res
        if (data) {
          this.visitListData = data
        }
      })
      findDetailInfoByStoreIdApi({ storeId: this.dataId }).then(res => {
        const { data } = res
        if (data) {
          this.usageListData = data
        }
      })
    },
    modalClose () {
      this.$emit('update:dialogVisible', false)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
